import BreadCrumb from 'Common/BreadCrumb'
import React from 'react'
import { Button, Card, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import StandardImageList from './update'


export default function Banner() {
  return (
    <React.Fragment>
    <div className="page-content">
        <Container fluid>
            <BreadCrumb title="Slider" pageTitle="Admin" />
            <Card>
            <Card.Header>
            <Link to={"/banner/create"}> <Button className="btn-primary   bg-gradient">Yarat</Button></Link>
            </Card.Header>
            <Card.Body>
            <StandardImageList/>
            </Card.Body>
          </Card>
            <Col lg={12}>
            
   
                
                </Col>
                
                </Container>
            </div>
            </React.Fragment>
  )
}
